import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";

import { LineChart, Line, XAxis, YAxis, Tooltip, CartesianGrid, ResponsiveContainer } from "recharts";
import { getZaehlerNummer } from "../api";

export default function ZählerDetails() {
  const { zaehlernummer } = useParams();
  const [zaehlerData, setZaehlerData] = useState(null);

  useEffect(() => {
    async function fetchData() {
      try {
        const result = await getZaehlerNummer(zaehlernummer); // ✅ await it!
        setZaehlerData(result);
      } catch (error) {
        console.error("Fehler beim Laden der Zählernummer:", error);
      }
    }
    fetchData();
  }, [zaehlernummer]);
  

  if (!zaehlerData) return <p>Lade Daten...</p>;

  // Format data for the chart (sorted oldest to newest)
  const chartData = zaehlerData.zaehlerstaende
    .map(entry => ({
      date: entry.date,
      verbrauch: entry.verbrauch
    }))
    .sort((a, b) => new Date(a.date) - new Date(b.date));

  return (
    <div style={{ padding: "20px", maxWidth: "600px", margin: "auto" }}>
      <h2>Zählernummer: {zaehlernummer}</h2>
      <p>Beschreibung: {zaehlerData.description}</p>

      <div style={{ backgroundColor: "#ffffff", padding: "10px", borderRadius: "8px", boxShadow: "0 0 10px rgba(0,0,0,0.1)" }}>
        <ResponsiveContainer width="100%" height={250}>
          <LineChart data={chartData}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="date" />
            <YAxis />
            <Tooltip />
            <Line type="monotone" dataKey="verbrauch" stroke="#8884d8" strokeWidth={2} />
          </LineChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}
